import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import reqwest from 'reqwest';
import { Form, Input, Button, Alert, notification, message, Spin, Modal} from 'antd';

const FormItem = Form.Item;

class AuthenticateSession extends React.Component{
  constructor(props){
    super(props);
    this.state={
      sessionID: "",
      sessionEmail: "",
      emailValidationMsg: null,
      sessIdValidationMsg: null,
      loading: false,
      sessIDValidated: false,
      visible: false,
    }
  }

  showModal = () => {
    this.setState({visible: true,});
  }

  closeModal = (e) => {
    this.setState({
      visible: false,
      emailValidationMsg: null,
    });
  }

  updateSessionID=(e)=>{
    this.setState({sessionID: e.target.value.trim()});
  }

  updateEmail=(e)=>{
    this.setState({sessionEmail: e.target.value.trim()});
  }

  handleSessionValidation=(e, url)=>{
    e.preventDefault();

    /**
     * For testing ONLY by hard coding a session ID and a fake email address
     */
    // this.props.auth(true, `metasess_5982077a2bf951.10052915`, `hello@email.com`);


    /**
     * input: this.state.sessionID
     * HttpRequest: POST 
     * return: success/fail message wether finding a valid session on server
     */
    this.setState({loading: true,});

    if(validateSessionID(this.state.sessionID)){
        // console.log(url);
      reqwest({
        url: url,
        method: 'post',
        crossOrigin: true,
        data: {sess_id: this.state.sessionID},
        success: (_data) => {
          // console.log(_data);
          let data = JSON.parse(_data);
          //console.log(data);
          //need to reset states, otherwise if statement will not be triggered
          this.setState({
            sessIdValidationMsg: null,
            sessionID: "",
            loading: false,
          });

          //output proper message
          if(data.error.length !== 0 ){
            notification.open({
                message: "Unable to authenticate session",
                description: `error: ${data.error}`,
                duration: 15,
                type: "error",
            });
            this.props.authCheck(false, "", "");
          }else{
            notification.open({
                message: "Session successfully authenticated",
                description: `Please proceed to complete your session.`,
                duration: 10,
                type: "success",
            });

            //use trim() to remove line breaks from php script
            this.props.auth(true, data.sess[0].trim(), data.sess[1].trim());
          } 
        },
        error: (error) => {
          this.setState({
            sessIdValidationMsg: null,
            sessionID: "",
            loading: false,
          });
          message.error('Connecting to iMetaLab server failed, unable to authenticate session.', 15);
        },
    });
    document.getElementById("session-id").value = "";
    }else{
      this.setState({
          sessIdValidationMsg: "invalid session ID.",
          sessionID: "",
          loading: false,
      })
      document.getElementById("session-id").value = "";
    }
  }


  // obtain a new session ID through email
  handleCreateSession=(e, url)=>{

    e.preventDefault();
    this.setState({loading: true,});
    
    if(validateEmail(this.state.sessionEmail)){
        
      reqwest({
        url: url,
        method: 'post',
        crossOrigin: true,
        data: {email: this.state.sessionEmail},
        success: (_data) => {
          // console.log(_data);
          let data = JSON.parse(_data);
          // console.log(data);
          //need to reset states, otherwise if statement will not be triggered
          this.setState({
            emailValidationMsg: null,
            sessionEmail: "",
            loading: false,
          });

          //output proper message
          if(data[0] === "The provided email was invalid"){
            notification.open({
              message: "Session was not created",
              description: `error: ${data}`,
              duration: 20,
              type: "error",
            });
          }else if(data[0] === "no valid email was provided"){
            notification.open({
              message: "Session was not created",
              description: `error: ${data}`,
              duration: 20,
              type: "error",
            });
          }else{
            if(data.error.length !== 0 ){
              notification.open({
                message: "Session was not created",
                description: `error: ${data.error}`,
                duration: 20,
                type: "error",
              });
            }else{
              notification.open({
                message: "Session successfully created",
                description: `The session ID was sent to ${data.sess.sess_email}`,
                duration: 20,
                type: "success",
              });
              this.setState({visible:false})
            } 
          }
        },
        error: (error) => {
          this.setState({
            emailValidationMsg: null,
            sessionEmail: "",
            loading: false,
          });
          message.error('Connecting to iMetaLab server failed, unable to create session.', 15);
        },
      });
      document.getElementById("session-email").value = "";
    }else{
      this.setState({
        emailValidationMsg: "invalid email address.",
        sessionEmail: "",
        loading: false,
      })
      document.getElementById("session-email").value = "";
    }
  }

  render(){
    // console.log(this.props);
    const {SERVER_APIS} = this.props;
    const {sessIdValidationMsg, emailValidationMsg, loading, visible} = this.state;

    return (
      <div css={css`
        width: 600px;
        margin: 0 auto;
      `}>
        <div css={css`
          width: 100%;
          margin-top: 50px;
          padding: 4%;
          background-color: #E1F5FE;
        `}>

          <Spin tip="submitting..." spinning={loading}>
            <div css={css`
              width: 80%;
              margin: 0 auto;
            `}>
              <div css={css`
                background: #B3E5FC; 
                padding: 10px; 
                text-align: center;
                margin: 25px;
                border-radius: 10px;
              `}>
                <h3>Create Session</h3>
              </div>

              <Form 
                onSubmit={(e)=>this.handleSessionValidation(e, `${SERVER_APIS.SERVER_URL}${SERVER_APIS.AUTHENTICATE_SESSION}`)}>

                <FormItem 
                  label="Session ID"
                  help="Enter the session ID you have received by Email"
                  required={true}
                  labelCol={{span: 24}}
                  wrapperCol={{span: 24}}>
                  <Input id="session-id" type="text" 
                    placeholder="e.g. metasess_5982077a2bf951.10052915" 
                    onChange={this.updateSessionID}/>
                </FormItem>

                <FormItem>
                  {
                    sessIdValidationMsg 
                    &&
                    <Alert description={sessIdValidationMsg} type="error"/>
                  }
                  <Button type="primary" htmlType="submit" 
                    size="large" 
                    style={{
                      width: '100%',
                      marginTop: '10px'
                    }}>Create session</Button>
                  <div 
                    css={css`
                      padding: 0px;
                      margin-top: 10px;
                      border: 1px solid steelblue;
                      border-radius: 5px;
                      cursor: pointer;
                      color: steelblue;
                      text-align: center;
                      &:hover{
                        font-weight: 600;
                        transition: 0.3s ease;
                      }
                    `}
                    onClick={this.showModal}>Obtain a new session ID
                  </div>
                </FormItem>
              </Form>
            </div>
          </Spin>
              
          <Modal 
            title="Obtain a new session ID"
            footer={null}
            visible={visible}
            onCancel={this.closeModal}>
            <Spin tip="submitting..." spinning={loading}>
              <div className="obtain-new-session-id-wrapper">
                <Form 
                  onSubmit={(e)=>this.handleCreateSession(e, `${SERVER_APIS.SERVER_URL}${SERVER_APIS.CREATE_SESSION}`)}>
                  <FormItem label="Email"
                    help="A unqiue session ID will be sent to the Email address provided above"
                    required={true}
                    labelCol={{span: 24}}
                    wrapperCol={{span: 24}}>
                    <Input id="session-email" 
                      type="text"   
                      placeholder="example@gmail.com" 
                      onChange={this.updateEmail}/>
                  </FormItem>

                  <FormItem>
                    {
                      emailValidationMsg 
                      &&
                      <Alert description={emailValidationMsg} type="error"/>
                    }
                    <Button type="primary" htmlType="submit" 
                      size="large" 
                      style={{
                        width: '100%',
                        marginTop: '10px'
                      }}>Get a new session ID</Button>
                  </FormItem>
                </Form>
              </div>
            </Spin>
          </Modal>
          
        </div>
      </div>
    );
  }
}

export default AuthenticateSession;

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validateSessionID(id){
  let _id = id.trim();
  if(_id === null || _id === "" || _id.length !== 32){
      return false;
  }else{
      return true;
  }
}
